export function msToTime (duration, round = true) {
  duration = Math.round(duration)
  const ms = duration % 1000
  duration = (duration - ms) / 1000
  const secs = duration % 60
  duration = (duration - secs) / 60
  const mins = duration % 60
  const hrs = (duration - mins) / 60
  return pad(hrs, 2) + ':' +
    pad(mins, 2) + ':' +
    (round
      ? pad(secs + Math.round(ms / 1000), 2)
      : pad(secs, 2) + '.' + pad(ms, 3))
}

function pad (n, z) {
  z = z || 2
  return ('00' + n).slice(-z)
}

// mixin
export default {
  methods: {
    msToTime
  }
}



// WEBPACK FOOTER //
// ./src/utils/ms-to-time.js